import moment from 'moment';

export const isValidDate = date => {
  const dateFormat = 'YYYY-MM-DD';
  return moment(moment(date).format(dateFormat),dateFormat,true).isValid();
};